'use client';

import { Suspense } from 'react';
import Header from './Header';
import { Skeleton } from './ui/skeleton';

function HeaderSkeleton() {
  return (
    <header className="bg-black dark:bg-gray-900 shadow-md sticky top-0 z-50">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-8 w-32" />
          <div className="hidden md:flex items-center space-x-8">
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-10 w-24" />
          </div>
          <Skeleton className="h-6 w-6 md:hidden" />
        </div>
      </nav>
    </header>
  );
}

export default function HeaderWrapper({ siteName, logoUrl }) {
  return (
    <Suspense fallback={<HeaderSkeleton />}>
      <Header siteName={siteName} logoUrl={logoUrl} />
    </Suspense>
  );
}

